import * as React from 'react';
import { ListSubheader, Typography, Menu, MenuItem, Divider } from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowDropDown } from '@mui/icons-material';
import { Selectors } from '../../selectors';
import { Actions } from '../../actions';
import * as PXBColors from '@brightlayer-ui/colors';
import { TrendChannelSelectors } from '../../selectors/trend-channel-selectors';

const MENU_ITEM_HEIGHT = 48;

export const ReusableTrendsCardHeader: React.FC<{
    title: string;
    isDevice?: boolean;
    fetchTrendData?: Function;
    count?: number;
    large?: boolean;
}> = (props) => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const trendDays = useSelector(Selectors.Dashboard.trendCardDays);
    const deviceTrendDays = useSelector(Selectors.Dashboard.deviceTrendCardDays);
    const days = props.isDevice ? deviceTrendDays : trendDays;
    const trendChannels = useSelector(TrendChannelSelectors.channelsForGraph);

    const onDaysChanged = (s: number): void => {
        if (props.isDevice) dispatch(Actions.Dashboard.deviceTrendCardDaysChanged(s));
        else dispatch(Actions.Dashboard.trendCardDaysChanged(s));

        if (props.isDevice) {
            return props.fetchTrendData && props.fetchTrendData(trendChannels, s);
        }
    };

    const [menuAnchor, setMenuAnchor]: [Element | null, Function] = React.useState(null);

    const menuItems: Array<{ label: string; onClick: Function }> = [
        {
            label: `1 ${t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.DAY')}`,
            onClick: (): void => {
                onDaysChanged(1);
            },
        },
        {
            label: `15 ${t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.DAYS')}`,
            onClick: (): void => {
                onDaysChanged(15);
            },
        },
        {
            label: `31 ${t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.DAYS')}`,
            onClick: (): void => {
                onDaysChanged(31);
            },
        },
    ];
    return (
        <>
            <ListSubheader
                color="primary"
                component="div"
                style={{ fontWeight: 600, display: 'flex', justifyContent: 'space-between' }}
            >
                {props.large ? (
                    <div style={{ flex: '1' }}>{props.title}</div>
                ) : (
                    <div style={{ flex: '1' }}>
                        {props.title}{' '}
                        {!props.isDevice && <span> {props.count === undefined ? 0 : props.count}/10</span>}
                    </div>
                )}

                <Typography
                    aria-haspopup="true"
                    onClick={(evt): void => {
                        setMenuAnchor(evt.currentTarget);
                    }}
                    style={{ display: 'inline-flex', cursor: 'pointer', marginTop: '14px', color: PXBColors.gray[800] }}
                    variant="body2"
                >
                    {days}{' '}
                    {days === 1
                        ? t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.DAY')
                        : t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.DAYS')}
                    {menuItems && menuItems.length > 0 && <ArrowDropDown style={{ marginLeft: 4 }} />}
                </Typography>

                <div style={{ display: 'inline-flex' }}>{props.children}</div>

                {menuItems && Boolean(menuAnchor) && (
                    <Menu
                        id="dropdown-toolbar-menu"
                        data-testid="dropdown-toolbar-menu"
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor)}
                        onClose={(): void => setMenuAnchor(null)}
                        MenuListProps={{ style: { padding: 0 } }}
                        PaperProps={{
                            style: {
                                maxHeight: MENU_ITEM_HEIGHT * 4.5,
                                width: 200,
                            },
                        }}
                    >
                        {menuItems.map((item, index) => (
                            // eslint-disable-next-line react/jsx-no-undef
                            <MenuItem
                                key={index}
                                onClick={(): void => {
                                    setMenuAnchor(null);

                                    item.onClick();
                                }}
                                style={{ height: MENU_ITEM_HEIGHT }}
                                data-testid={index}
                            >
                                {item.label}
                            </MenuItem>
                        ))}
                    </Menu>
                )}
            </ListSubheader>

            <Divider />
        </>
    );
};
